import React from 'react';
import map from 'lodash/map';
import BackgroundTimeline from './BackgroundTimeline';
import Day from './Day';
import Timeline from './Timeline';
import './style.scss';

const Week = ({ days, isFavoriteClass, courses }) => {
  const events = days.events || days

  // console.debug(`[events] - ${JSON.stringify(events, null, 2)}`)
  let latestHour = events.reduce((memo, item) => {
    let hour = item.reduce((memo, item) => {
      const matches = item.time.match(/-(\d+):(\d\d) (.)m/)
      const raw_hour = parseInt(matches[1])
      const add_me = parseInt(matches[2]) > 0 ? 1 : 0
      const is_pm = matches[3] == 'p'
      const hour = is_pm && raw_hour !== 12 ? raw_hour + 12 + add_me : raw_hour + add_me
      return hour > memo ? hour : memo
    }, 0)
    return hour > memo ? hour : memo
  }, 0)
  latestHour = latestHour < 17 ? 17 : latestHour + 1
  latestHour = latestHour > 22 ? 22 : latestHour

  if (events.length === 0) {
    latestHour = 17
  }
  return (
    <div>
      <Timeline latestHour={latestHour}/>
      <div className="eventsContainer">
        <BackgroundTimeline latestHour={latestHour}>
          {
            map(events, (d, i) => {
              return<div key={`day-${i}`} className="weekDay">
                {i == 0 ? <div className="dayThead"><div className="theadTitle">Monday</div></div> : null}
                {i == 1 ? <div className="dayThead"><div className="theadTitle">Tuesday</div></div> : null}
                {i == 2 ? <div className="dayThead"><div className="theadTitle">Wednesday</div></div> : null}
                {i == 3 ? <div className="dayThead"><div className="theadTitle">Thursday</div></div> : null}
                {i == 4 ? <div className="dayThead"><div className="theadTitle">Friday</div></div> : null}
                {i == 5 ? <div className="dayThead"><div className="theadTitle">Saturday</div></div> : null}
                {i == 6 ? <div className="dayThead"><div className="theadTitle">Sunday</div></div> : null}
                <Day
                  events={d}
                  isFavoriteClass={isFavoriteClass}
                  courses={courses}
                  nhours={latestHour-7}
                />
              </div>;
            })
          }
        </BackgroundTimeline>
      </div>
    </div>
  );
}

export default Week;



// WEBPACK FOOTER //
// ./src/components/common/Calendar/Week.js